<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="title-color">
            <h1>EDITAR UBICACIÓN</h1>
        </div>
        <div class="form-body">
            <form [formGroup]="editLocationForm" (ngSubmit)="updateLocation()">
                <div class="line column-md-12">
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Código de país</mat-label>
                            <input
                                type="number"
                                matInput
                                placeholder="Código de país"
                                formControlName="countryCode"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editLocationForm
                                        .get('countryCode')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>País</mat-label>
                            <input
                                matInput
                                placeholder="País"
                                formControlName="country"
                                oninput="this.value = this.value.toUpperCase()"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editLocationForm
                                        .get('country')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Código de departamento</mat-label>
                            <input
                                type="number"
                                matInput
                                placeholder="Código de departamento"
                                formControlName="departmentCode"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editLocationForm
                                        .get('departmentCode')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Departamento</mat-label>
                            <input
                                matInput
                                placeholder="Departamento"
                                formControlName="department"
                                oninput="this.value = this.value.toUpperCase()"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editLocationForm
                                        .get('department')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Código de ciudad</mat-label>
                            <input
                                type="number"
                                matInput
                                placeholder="Código de ciudad"
                                formControlName="cityCode"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editLocationForm
                                        .get('cityCode')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Ciudad</mat-label>
                            <input
                                matInput
                                placeholder="Ciudad"
                                formControlName="city"
                                oninput="this.value = this.value.toUpperCase()"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editLocationForm
                                        .get('city')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <button type="submit" class="primary-button" id="guardar">
                    <span class="button-content"
                        ><mat-icon>save</mat-icon>Guardar</span
                    >
                </button>
                <button
                    type="button"
                    (click)="closeDialog()"
                    class="secondary-button"
                    id="cancelar"
                >
                    <span class="button-content"
                        ><mat-icon>close</mat-icon>Cancelar</span
                    >
                </button>
            </form>
        </div>
    </div>
</div>
